
export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",
        },
        {
            title: "Vendor Name",
            value: "vendorName",
            type: "configue",
        },
        {
            title: "Vendor Account Name",
            value: "vendorAccountName",
            type: "configue",
        },
        {
            title: "Project Name",
            value: "projectName",
            type: "configue",
        },
        {
            title: "External Session ID",
            value: "externalSessionId",
            type: "configue",
        },
        {
            title: "Session Type",
            value: "sessionType",
            type: "configue",
        },
        {
            title: "Status",
            value: "status",
            type: "configue",
        },
       
    ],
secondaryData: [
     {
            title: "Scheduled Start",
            value: "scheduledStartTime",
            type: "configue",
        },
        {
            title: "Scheduled End",
            value: "scheduledEndTime",
            type: "configue",
        },
        {
            title: "Actual Start",
            value: "actualStartTime",
            type: "configue",
        },
        {
            title: "Actual End",
            value: "actualEndTime",
            type: "configue",
        },
        {
            title: "Created At",
            value: "createdAt",
            type: "configue",
        },
        {
            title: "Updated At",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt"
        },
        {
            title: "Created By",
            value: "createdByName",
            type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            type: "configue",
            name: "updatedByName"
        },
],
};

export type liveSessions = {
    id: string;
    vendorId: string;
    vendorAccountId: string;
    externalSessionId: string;
    sessionType: string;
    status: string;
    scheduledStartTime: string;
    scheduledEndTime: string;
    actualStartTime: string;
    actualEndTime: string;
    createdAt: string;
    updatedAt: string;
    createdById: string;
    updatedById: string;
    createdByName: string;
    updatedByName: string;
};

export const liveSessionsInitialValues: liveSessions = {
    id: "",
    vendorId: "",
    vendorAccountId: "",
    externalSessionId: "",
    sessionType: "",
    status: "",
    scheduledStartTime: "",
    scheduledEndTime: "",
    actualStartTime: "",
    actualEndTime: "",
    createdAt: "",
    updatedAt: "",
    createdById: "",
    updatedById: "",
    createdByName: "",
    updatedByName: "",
};
